import { Card, Grid } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiButton from "components/VuiButton";
import VuiTypography from "components/VuiTypography";
import { useAuth } from "context/AuthContext";
import { useState } from "react";
import { supabase } from "supabaseClient";

const SecuritySettings = () => {
  const { user } = useAuth();
  const [qrCode, setQrCode] = useState(null);

  const handlePasswordReset = async () => {
    const { error } = await supabase.auth.resetPasswordForEmail(user.email);
    if (error) {
      alert(error.message);
    } else {
      alert(`Link para redefinição de senha enviado para ${user.email}`);
    }
  };

  const handleEnable2FA = async () => {
    const { data, error } = await supabase.auth.mfa.enroll();
    if (error) {
      alert(error.message);
    } else {
      setQrCode(data.totp.qr_code);
    }
  };

  return (
    <Card sx={{ height: "100%" }}>
      <VuiBox display="flex" flexDirection="column" height="100%">
        <VuiBox display="flex" flexDirection="column" mb="24px">
          <VuiTypography color="white" variant="lg" fontWeight="bold" mb="6px">
            Segurança
          </VuiTypography>
        </VuiBox>
        <VuiBox>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <VuiButton
                onClick={handlePasswordReset}
                variant="contained"
                sx={{
                  backgroundColor: "#0075FF",
                  color: "white",
                  transition: "transform 0.3s ease-in-out",
                  "&:hover": {
                    backgroundColor: "#0075FF",
                    transform: "scale(1.02)",
                  },
                }}
                fullWidth
              >
                Trocar Senha
              </VuiButton>
            </Grid>
            <Grid item xs={12}>
              <VuiButton
                onClick={handleEnable2FA}
                variant="contained"
                sx={{
                  backgroundColor: "#0075FF",
                  color: "white",
                  transition: "transform 0.3s ease-in-out",
                  "&:hover": {
                    backgroundColor: "#0075FF",
                    transform: "scale(1.02)",
                  },
                }}
                fullWidth
              >
                Ativar 2FA
              </VuiButton>
            </Grid>
            {qrCode && (
              <Grid item xs={12}>
                <VuiTypography color="white">Escaneie o QR Code com seu app de autenticação:</VuiTypography>
                <div dangerouslySetInnerHTML={{ __html: qrCode }} />
              </Grid>
            )}
          </Grid>
        </VuiBox>
      </VuiBox>
    </Card>
  );
};

export default SecuritySettings;